// extracted by mini-css-extract-plugin
export default {"wrap":"absence_wrap__vYjLh","absence__panel":"absence_absence__panel__QmH6k","btnGroup":"absence_btnGroup__5noht"};